<template>
  <div>
    <common-header title="설문조사" :showTitle="true" :showCart="false" :showHome="true" :showBack="true"/>
    <main class="survey_q_bg">
      <div class="header">
        <h4>{{ fetchedSelectSurvey.surveyName }}</h4>
      </div>
      <div class="content" v-html="lineChange(fetchedSelectSurvey.content)"/>
      <div>
        <button type="button" class="btn btn-full btn-primary footer-bottom" @click="changeSurveyQuestionView">설문조사 시작
        </button>
      </div>
    </main>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {YN} from "../AppConstants";

export default {
  created() {
    // TODO 네비게이션 가드로 리팩토링
    // 로그인 상태 체크
    if (this.loginState != true) {
      this.$router.push('/')
      return;
    }

    // 설문조사 조회
    const surveyId = this.$route.params.surveyId;

    // 검증 여부 초기화
    this.SET_VALIDATE_YN(YN.N);

    // 설문조사 단건 조회
    this.showLoading(true);
    this.FETCH_SELECT_SURVEY(surveyId)
      .then(response => {
        if (response.code !== '0000') {
          this.showAlert(response.message);
        }
      })
      .catch(error => this.showAlert("설문조사 조회에 실패했습니다."))
      .finally(() => this.showLoading(false))
  },
  computed: {
    ...mapGetters(['fetchedSelectSurvey', 'fetchedSurveyAnswerYn'])
  },
  methods: {
    ...mapMutations(['SET_VALIDATE_YN']),
    ...mapActions(['FETCH_SELECT_SURVEY', 'FETCH_VALIDATE_YN']),
    changeSurveyQuestionView() {

      // 설문조사 답변 가능 여부 검증
      this.showLoading(true);

      this.FETCH_VALIDATE_YN(this.$route.query.surveyMemberId)
        .then(response => {
          if (response.code === '0000') {
            // 설문조사 질문으로 이동
            this.$router.push({
              path: `/survey/${this.$route.params.surveyId}/questions`,
              query: {surveyMemberId: this.$route.query.surveyMemberId}
            });
          } else {
            this.showAlert(response.message);
          }
        })
        .catch(error => this.showAlert("설문조사 답변 가능 여부 검증에 실패했습니다."))
        .finally(() => this.showLoading(false))
    },
    lineChange(txt) {
      if (txt.length > 0) {
        return txt.replaceAll("\n", "<br/>");
      } else {
        return "";
      }

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/survey/Survey.vue